module.exports = __webpack_public_path__ + "12029684d8dd60dd4594a5faab6f311a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/beady-29.png
// module id = 2089
// module chunks = 0